import Input from '@lt/components/components/Form/components/Input';
import { useTranslation } from '@lt/localization';
import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { orderNumberValidationSchema } from './validationSchemas';
import type { FormProps } from '../../../types';

const OrderNumberForm = (props: FormProps): JSX.Element => {
  const { fieldValue, setFieldValue } = props;
  const { t } = useTranslation();
  const labelText = t('checkout.services.jointOrder.additionalOrder.labelText');
  const initialValues = {
    orderNumber: fieldValue || '',
  };
  const handleBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(Number(event.target.value));
  };
  useEffect(() => {
    setFieldValue(fieldValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Formik
      validationSchema={orderNumberValidationSchema}
      validateOnBlur
      initialValues={initialValues}
      onSubmit={() => undefined}
    >
      <Form>
        <InputContainer>
          <StyledLabel>{labelText}</StyledLabel>
          <StyledInput
            name="orderNumber"
            placeholder="000000000"
            type="number"
            height={40}
            onBlur={handleBlur}
            withoutSuccessIcon
          />
        </InputContainer>
      </Form>
    </Formik>
  );
};

const StyledLabel = styled.div`
  font-size: 12px;
  padding: 0px 2px;
  color: #4d4d4d;
`;

const InputContainer = styled.div`
  display: flex;
  width: 291px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  &:nth-child(2) {
    height: 40px;
  }
`;

const StyledInput = styled(Input)`
  width: 100%;
  display: flex;
  flex-direction: column;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export default OrderNumberForm;
